import s from './ItemMainModal.module.css';
import React, { useCallback, useEffect, useState } from "react";
import CardModal from './CardModal';

export default function ItemMainModal ({rawItem, item, setItem, show, setShow}){		
		if (!item) {
			return (<></>);
		}
		
		return (
			<div>
				<div className={[s.modalContentWrapperSide, (show ? s.bShow: s.bHide)].join(' ')}>			
						<div className={s.itemId}>
							<div>{item.id}</div>
							<div className={s.itemType}>Type - {item.itemType}</div>
						</div>
						<div className={s.itemName}>{item.name}</div>
						<div className={s.thumbnailPath}><img src={item.thumbnailPath}  alt="icon"/></div>
				</div>
				<div className={[s.modalContentWrapper, (show ? s.cShow: s.cHide)].join(' ')}>			
					{(item.itemType == 71) && (<CardModal rawItem={rawItem} item={item} setItem={setItem}/>)}
				</div>
				<div className={[s.modalBackdrop, (show ? s.modal : s.modalHide)].join(' ')} onClick={()=>{ setShow(false)}}/>
			</div>);
}